<template>
  <div class="follow-detail-page">
    <!-- 顶部返回栏 -->
    <div class="top-bar">
      <el-button type="text" @click="router.back()" class="back-btn">← 返回</el-button>
      <h2 class="page-title">客户详情</h2>
    </div>

    <!-- 加载状态 -->
    <el-skeleton v-if="loading" :rows="12" animated />

    <!-- 客户信息卡片（加载完成后显示） -->
    <div class="info-row">
  <div class="info-col">
    <span class="info-label">客户姓名：</span>
    <span class="info-value">{{ daodianInfo.name || '-' }}</span>
  </div>
</div>
<div class="info-row">
  <div class="info-col">
    <span class="info-label">客户电话：</span>
    <span class="info-value">{{ daodianInfo.phone || '-' }}</span>
    <el-button
      v-if="daodianInfo.phone"
      type="primary"
      @click="callPhone(daodianInfo.phone)"
      class="call-btn"
      size="mini"
    >
      拨打电话
    </el-button>
  </div>

      <!-- 签约状态 + 数据状态（一行两列） -->
      <div class="info-row force-two-col">
        <div class="info-col">
          <span class="info-label">签约状态：</span>
          <template v-if="!daodianInfo.is_signed">
            <el-select
              v-model="form.isSigned"
              class="info-select"
              placeholder="选择签约状态"
              @change="handleSignChange"
            >
              <el-option label="未签约" value="false"></el-option>
              <el-option label="已签约" value="true"></el-option>
            </el-select>
          </template>
          <template v-else>
            <span class="info-value status-signed">已签约</span>
          </template>
        </div>
        <div class="info-col">
          <span class="info-label">数据状态：</span>
          <el-select
            v-model="form.isLost"
            class="info-select"
            placeholder="选择数据状态"
            @change="handleLostChange"
            :disabled="daodianInfo.is_signed"
          >
            <el-option label="正常" value="false"></el-option>
            <el-option label="流失该数据" value="true"></el-option>
          </el-select>
        </div>
      </div>

      <!-- 到店类型 + 意向度（一行两列） -->
      <div class="info-row force-two-col">
        <div class="info-col">
          <span class="info-label">到店类型：</span>
          <el-select
            v-model="form.leixing_id"
            placeholder="请选择到店类型"
            class="info-select"
            :disabled="daodianInfo.is_signed"
          >
            <el-option
              v-for="item in leixingList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="info-col">
          <span class="info-label">意向度：</span>
          <el-select
            v-model="form.yixiangdu"
            placeholder="请选择意向度"
            class="info-select"
            :disabled="daodianInfo.is_signed"
          >
            <el-option label="高意向" value="A"></el-option>
            <el-option label="中意向" value="B"></el-option>
            <el-option label="低意向" value="C"></el-option>
          </el-select>
        </div>
      </div>

      <!-- 流失原因（单独一行） -->
      <div class="info-row" v-if="form.isLost === 'true' && !daodianInfo.is_signed">
        <div class="info-col full-width-col">
          <span class="info-label">流失原因：</span>
          <el-input
            v-model="form.lostReason"
            placeholder="请输入流失原因（至少5个字符）"
            type="textarea"
            rows="2"
            class="lost-reason-input"
          ></el-input>
        </div>
      </div>

      <!-- 补充信息行 -->
      <div class="info-row">
        <div class="info-col">
          <span class="info-label">客户年龄：</span>
          <span class="info-value">{{ daodianInfo.age ? daodianInfo.age + '岁' : '-' }}</span>
        </div>
        <div class="info-col">
          <span class="info-label">客户地址：</span>
          <span class="info-value">{{ daodianInfo.dizhi || '-' }}</span>
        </div>
      </div>

      <!-- 归属信息行 -->
      <div class="info-row">
        <div class="info-col">
          <span class="info-label">所属员工：</span>
          <span class="info-value">{{ daodianInfo.user?.name || '-' }}</span>
        </div>

      </div>

      <!-- 时间信息行 -->
      <div class="info-row">
        <div class="info-col">
          <span class="info-label">到店时间：</span>
          <span class="info-value">{{ formatTime(daodianInfo.arrival_time) || '-' }}</span>
        </div>
        <div class="info-col">
          <span class="info-label">更新时间：</span>
          <span class="info-value">{{ formatTime(daodianInfo.update_time) || '-' }}</span>
        </div>
      </div>

      <!-- 描述信息行 -->
      <div class="info-row full-width">
        <div class="info-col full-width-col">
          <span class="info-label">情况描述：</span>
          <span class="info-value-full">{{ daodianInfo.qinkuang_miaoshu || '-' }}</span>
        </div>
      </div>
    </div>

    <!-- 保存按钮 -->
    <el-button
      v-if="!loading && !daodianInfo.is_signed"
      type="success"
      class="save-btn"
      @click="saveAllChanges"
      :loading="saveLoading"
    >
      保存所有修改
    </el-button>

    <!-- 已签约提示 -->
    <div v-if="!loading && daodianInfo.is_signed" class="status-tip">
      <el-icon style="color: #52c41a">
        <InfoFilled />
      </el-icon>
      <span>已签约客户不可修改信息</span>
    </div>

    <!-- 跟进记录区域 -->
    <div class="follow-records-section">
      <h3 class="section-title">跟进记录</h3>

      <el-form
        v-if="!daodianInfo.is_signed"
        :model="followForm"
        ref="followFormRef"
        label-width="70px"
        class="follow-form"
        :rules="formRules"
      >
        <el-form-item label="跟进内容" prop="jilu">
          <el-input
            v-model="followForm.jilu"
            placeholder="请输入跟进内容（至少5个字符）..."
            type="textarea"
            rows="3"
            style="resize: none;"
            class="follow-textarea"
          ></el-input>
        </el-form-item>
        <el-form-item class="form-item-right">
          <el-button
            type="primary"
            @click="addFollowRecord"
            :loading="followLoading"
          >
            添加跟进记录
          </el-button>
        </el-form-item>
      </el-form>

      <div class="records-container">
        <el-skeleton v-if="followLoading" :rows="3" style="width: 100%;" />

        <div v-else-if="followRecords.length > 0" class="record-list">
          <div
            v-for="(record, index) in followRecords"
            :key="index"
            class="record-item"
          >
            <div class="record-header">
              <span class="record-operator">跟进人：{{ record.user?.name || '-' }}</span>
              <span class="record-time">{{ formatDateTime(record.time) }}</span>
            </div>
            <div class="record-content">{{ record.jilu || '-' }}</div>
          </div>
        </div>

        <div v-else class="no-record">暂无跟进记录</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, watch, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import request from "@/util/request";
import {
  ElMessage, ElSkeleton, ElSelect, ElOption, ElButton,
  ElForm, ElFormItem, ElInput, ElIcon, ElTooltip
} from "element-plus";
import { InfoFilled, PhoneOutline } from "@element-plus/icons-vue";

export default {
  name: "MobileFollowDetail",
  components: {
    ElSkeleton, ElSelect, ElOption, ElButton,
    ElForm, ElFormItem, ElInput, ElIcon, ElTooltip,
    InfoFilled, PhoneOutline
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    // 状态管理
    const loading = ref(true);
    const saveLoading = ref(false);
    const followLoading = ref(false);
    const daodianInfo = ref({});
    const leixingList = ref([]);
    const followFormRef = ref(null);

    // 表单数据
    const form = reactive({
      isSigned: "false",     // 签约状态
      isLost: "false",       // 流失状态
      lostReason: "",        // 流失原因
      yixiangdu: "",         // 意向度
      leixing_id: ""         // 到店类型ID
    });

    // 跟进记录表单
    const followForm = reactive({ jilu: "" });
    const formRules = {
      jilu: [
        { required: true, message: "请输入跟进内容", trigger: "blur" },
        { min: 5, message: "跟进内容至少5个字符", trigger: "blur" }
      ]
    };
    const followRecords = ref([]);

    // 时间格式化
    const formatTime = (timeStr) => {
      if (!timeStr) return "";
      try {
        const date = new Date(timeStr);
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
      } catch (err) {
        return timeStr.slice(0, 16);
      }
    };

    const formatDateTime = (timeStr) => {
      if (!timeStr) return "";
      try {
        const date = new Date(timeStr);
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
      } catch (err) {
        return timeStr;
      }
    };

    // 拨打电话
    const callPhone = (phone) => {
      if (!phone) {
        ElMessage.warning("暂无客户电话");
        return;
      }
      window.location.href = `tel:${phone}`;
    };

    // 签约状态变更
    const handleSignChange = (value) => {
      form.isSigned = value;
      if (value === "true") {
        form.isLost = "false";
        form.lostReason = "";
      }
    };

    // 流失状态变更
    const handleLostChange = (value) => {
      form.isLost = value;
      if (value === "true") {
        form.isSigned = "false";
      } else {
        form.lostReason = "";
      }
    };

    // 获取到店类型列表
    const getLeixingList = async () => {
      try {
        const res = await request.get("/api/leixing/");
        if (res.data.code === 200) {
          leixingList.value = res.data.data || [];
        } else {
          ElMessage.error(res.data.message || "获取到店类型失败");
        }
      } catch (err) {
        console.error("获取到店类型失败：", err);
        ElMessage.error("网络异常，获取到店类型失败");
      }
    };

    // 获取客户详情
    const getDaodianDetail = async () => {
      const daodianId = route.query.daodianId;
      if (!daodianId) {
        ElMessage.error("缺少客户ID");
        return;
      }
      loading.value = true;
      try {
        const res = await request.get(`/api/daodian/${daodianId}/`);
        if (res.data.code === 200) {
          daodianInfo.value = res.data.data || {};
          form.isSigned = daodianInfo.value.is_signed === true ? "true" : "false";
          form.isLost = daodianInfo.value.is_lost === true ? "true" : "false";
          form.yixiangdu = daodianInfo.value.yixiangdu || "";
          form.leixing_id = daodianInfo.value.leixing?.id || "";
        } else {
          ElMessage.error(res.data.message || "获取客户信息失败");
        }
      } catch (err) {
        console.error("获取客户信息失败：", err);
        ElMessage.error("网络异常，获取客户信息失败");
      } finally {
        loading.value = false;
      }
    };

    // 获取跟进记录
    const getFollowRecords = async () => {
      const daodianId = route.query.daodianId;
      if (!daodianId) {
        ElMessage.warning("缺少客户ID，无法获取跟进记录");
        return;
      }
      followLoading.value = true;
      try {
        const res = await request.get(`/api/daodian/${daodianId}/follow/`);
        if (res.data.code === 200) {
          followRecords.value = (res.data.data || []).sort(
            (a, b) => new Date(b.time) - new Date(a.time)
          );
        } else {
          ElMessage.error(res.data.message || "获取跟进记录失败");
        }
      } catch (err) {
        console.error("获取跟进记录失败：", err);
        ElMessage.error("网络异常，无法获取跟进记录");
      } finally {
        followLoading.value = false;
      }
    };

    // 保存所有修改
    const saveAllChanges = async () => {
      const daodianId = route.query.daodianId;
      if (!daodianId) {
        ElMessage.error("缺少客户ID");
        return;
      }
      if (daodianInfo.value.is_signed) {
        ElMessage.warning("已签约客户不可修改信息");
        return;
      }
      if (form.isLost === "true" && (!form.lostReason.trim() || form.lostReason.trim().length < 5)) {
        ElMessage.error("流失原因至少需要5个字符");
        return;
      }
      if (form.isSigned === "true" && form.isLost === "true") {
        ElMessage.error("签约和流失状态不能同时存在");
        return;
      }

      const submitData = {
        yixiangdu: form.yixiangdu,
        leixing_id: form.leixing_id,
        is_signed: form.isSigned === "true",
        is_lost: form.isLost === "true",
        lost_reason: form.lostReason.trim() || ""
      };

      saveLoading.value = true;
      try {
        const res = await request.put(`/api/daodian/aa/${daodianId}/`, submitData, {
          headers: { 'Content-Type': 'application/json' }
        });

        if (res.data.code === 200) {
          daodianInfo.value = res.data.data;
          form.isSigned = daodianInfo.value.is_signed === true ? "true" : "false";
          form.isLost = daodianInfo.value.is_lost === true ? "true" : "false";
          ElMessage.success("所有修改保存成功");
        } else {
          ElMessage.error(res.data.message || "保存失败");
        }
      } catch (err) {
        console.error("保存修改失败：", err);
        ElMessage.error("网络异常，保存失败");
      } finally {
        saveLoading.value = false;
      }
    };

    // 添加跟进记录
    const addFollowRecord = async () => {
      const daodianId = route.query.daodianId;
      if (!daodianId) {
        ElMessage.error("未关联到店记录");
        return;
      }
      if (daodianInfo.value.is_signed) {
        ElMessage.warning("已签约客户无需添加跟进记录");
        return;
      }
      if (!followFormRef.value) return;

      try {
        await followFormRef.value.validate();
        const res = await request.post(`/api/daodian/${daodianId}/follow/`, followForm);
        if (res.data.code === 200 || res.data.code === 201) {
          ElMessage.success("跟进记录添加成功");
          followForm.jilu = "";
          getFollowRecords();
        } else {
          ElMessage.error(res.data.message || "添加失败");
        }
      } catch (err) {
        if (err.name !== "ValidationError") {
          console.error("添加跟进记录失败：", err);
          ElMessage.error("网络异常，添加失败");
        }
      }
    };

    // 监听路由参数变化
    watch(() => route.query.daodianId, (newId) => {
      if (newId) {
        getDaodianDetail();
        getFollowRecords();
      }
    });

    // 初始化加载
    onMounted(() => {
      getLeixingList();
      if (route.query.daodianId) {
        getDaodianDetail();
        getFollowRecords();
      }
    });

    return {
      router,
      loading,
      saveLoading,
      followLoading,
      daodianInfo,
      leixingList,
      form,
      followFormRef,
      followForm,
      formRules,
      followRecords,
      formatTime,
      formatDateTime,
      callPhone,
      handleSignChange,
      handleLostChange,
      saveAllChanges,
      addFollowRecord
    };
  }
};
</script>

<style scoped>
.follow-detail-page {
  padding: 12px;
  background-color: #f5f7fa;
  min-height: 100vh;
  font-family: "Microsoft Yahei", sans-serif;
}

/* 顶部返回栏 */
.top-bar {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.back-btn {
  font-size: 14px;
  color: #ff7f24;
  padding: 0;
}
.page-title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #333;
}

/* 客户信息卡片 */
.info-card {
  background-color: #fff;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #eee;
}
.info-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
  gap: 10px;
}
.info-row:last-child {
  margin-bottom: 0;
}
.info-col {
  flex: 1;
  min-width: 180px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.full-width-col {
  width: 100%;
}
.info-label {
  min-width: 70px;
  color: #666;
  font-weight: 500;
}
.info-value {
  color: #333;
  flex: 1;
  word-break: break-all;
}
.info-select {
  width: 100%;
  min-width: 150px;
}
.info-value-full {
  color: #333;
  width: calc(100% - 70px);
  word-break: break-all;
  line-height: 1.6;
}

/* 强制两列布局 */
.force-two-col {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.force-two-col .info-col {
  min-width: calc(50% - 5px);
}

/* 状态样式 */
.status-signed {
  color: #52c41a;
  font-weight: 500;
}
.status-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #52c41a;
  padding: 10px;
  background-color: #f6ffed;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 14px;
}

/* 按钮样式 */
.call-btn {
  padding: 4px 8px;
  white-space: nowrap;
}
.save-btn {
  width: 100%;
  margin-bottom: 20px;
  padding: 10px 0;
}

/* 跟进记录区域 */
.follow-records-section {
  background-color: #fff;
  padding: 16px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #eee;
}
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

/* 跟进表单 */
.follow-form {
  background-color: #f9f9f9;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 16px;
}
.follow-textarea {
  width: 100%;
}
.form-item-right {
  display: flex;
  justify-content: flex-end;
}

/* 记录列表 */
.records-container {
  margin-top: 10px;
}
.record-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.record-item {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 12px;
  background-color: #f9f9f9;
}
.record-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 12px;
  color: #888;
}
.record-content {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
}
.no-record {
  text-align: center;
  color: #999;
  padding: 20px 0;
  font-size: 13px;
}

/* 流失原因输入框 */
.lost-reason-input {
  width: calc(100% - 85px);
  margin-top: 4px;
}

/* 响应式调整 */
@media (max-width: 375px) {
  .info-col {
    min-width: 100%;
  }
  .info-value-full {
    width: 100%;
    margin-top: 4px;
  }
  .force-two-col {
    flex-wrap: wrap;
  }
  .force-two-col .info-col {
    min-width: 100%;
    margin-bottom: 10px;
  }
}
</style>